<div class="cq-app-container">
  <div class="cq-app-main" id="pdfPrint">
    <div class="cq-app-header">
      <div [ngClass]="{ 'no-export': !isPdfExporting, 'has-export': isPdfExporting }">
        <cq-header></cq-header>
      </div>
    </div>

    <div class="app-container" id="pdfPrintExt">
      <main [ngClass]="{ 'app-main': true, 'no-export': !isPdfExporting, 'has-export': isPdfExporting }">
        <router-outlet></router-outlet>
      </main>
    </div>

    <div class="cq-app-footer">
      <div [ngClass]="{ 'no-export': !isPdfExporting, 'has-export': isPdfExporting }">
        <cq-footer></cq-footer>
      </div>
    </div>
  </div>
</div>
